import React from 'react';
import { unwrapModel } from '../../../../../services/api/unwrapModel';
import EditLocationForm from '../EditLocationForm';
import { useGetAllRoomPositionsForShareSuspense } from '../../../../../services/api/generated/client';
import { useInspectionDetailShareContext } from '../../../../pages/upgrade/InspectionDetail/ShareInspection/InspectionDetailShareProvider';
const EditLocationFormShareWrapper = (props) => {
    const { token } = useInspectionDetailShareContext();
    const { data: roomPositionsResponse } = useGetAllRoomPositionsForShareSuspense(token, {
        query: {
            staleTime: Infinity,
            refetchOnMount: false,
        },
    });
    const roomPositions = unwrapModel(roomPositionsResponse);
    if (!roomPositions)
        return null;
    return React.createElement(EditLocationForm, { ...props, roomPositions: roomPositions });
};
export default EditLocationFormShareWrapper;
